import { render, staticRenderFns } from "./ot-project-user-contracts-table.vue?vue&type=template&id=6b94b1e4&scoped=true&"
import script from "./ot-project-user-contracts-table.vue?vue&type=script&lang=ts&"
export * from "./ot-project-user-contracts-table.vue?vue&type=script&lang=ts&"
import style0 from "./ot-project-user-contracts-table.vue?vue&type=style&index=0&id=6b94b1e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b94b1e4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VMenu})
